export interface FeatureDef {
  featureId: string;
  comingSoon?: boolean;
}

export interface FeatureCategory {
  id: string;
  comingSoon?: boolean;
  features: FeatureDef[];
}

export interface FeatureUsage {
  featureId: string;
  runCount?: number;
  creditsConsumed?: number;
}

export interface GroupedFeature {
  featureId: string;
  comingSoon: boolean;
  runCount: number;
  creditsConsumed: number;
}

export const FEATURE_CATEGORIES: FeatureCategory[] = [
  {
    id: "controls",
    features: [
      { featureId: "control_submitted" },
      { featureId: "report_exported" },
      { featureId: "email_sent" },
    ],
  },
  {
    id: "resources",
    features: [
      { featureId: "resource_created" },
      { featureId: "import_batch", comingSoon: true },
    ],
  },
  {
    id: "ai",
    comingSoon: true,
    features: [{ featureId: "textract_run" }, { featureId: "stt_run" }],
  },
];

const FEATURE_TO_CATEGORY: Record<string, string> = FEATURE_CATEGORIES.reduce(
  (acc, cat) => {
    cat.features.forEach((f) => {
      acc[f.featureId] = cat.id;
    });
    return acc;
  },
  {} as Record<string, string>
);

export function getCategoryForFeature(featureId: string): string {
  return FEATURE_TO_CATEGORY[featureId] || "other";
}

export function groupFeaturesByCategory(
  features: FeatureUsage[]
): Record<string, GroupedFeature[]> {
  return FEATURE_CATEGORIES.reduce(
    (acc, cat) => {
      acc[cat.id] = cat.features.map((featDef) => {
        const match = features.find((f) => f.featureId === featDef.featureId);
        return {
          featureId: featDef.featureId,
          comingSoon: !!featDef.comingSoon,
          runCount: match?.runCount ?? 0,
          creditsConsumed: match?.creditsConsumed ?? 0,
        };
      });
      return acc;
    },
    {} as Record<string, GroupedFeature[]>
  );
}
